export default __webpack_public_path__ + "static/media/toilet_desk.d858cb48.png";